import {
  FETCH_ROOM_GROUPS,
  FETCH_ROOM_GROUPS_SUCCESS,
  FETCH_ROOM_GROUPS_FAILURE,
  SET_STATE_SEARCH
} from '../actions/search'

export const initialState = {
  destination: '',
  lat: null,
  lon: null,
  radius: null,
  prefecture: '',
  feature_title: '',
  feature_url: '',
  checkin: null,
  checkout: null,
  adults: '',
  guests: '',
  price_min: '',
  price_max: '',
  instant: '',
  room_types: '',
  room_groups: [],
  rooms: [],
  property_types: [],
  offset: 0,
  total_count: 0,
  currentPage: 0,
  sort: 'distance_asc',
  isMapMode: false,
  isFetched: false,
  isSP: null,
  isTablet: null,
  tiles: new Map(),
  error: null
}

export default function searchReducer(state = initialState, action){
  switch(action.type) {
  case FETCH_ROOM_GROUPS:
    return {
      ...state,
      isFetched: false,
      error: null
    }
  case FETCH_ROOM_GROUPS_SUCCESS:
    return {
      ...state,
      isFetched: true,
      ...action.payload
    }
  case FETCH_ROOM_GROUPS_FAILURE:
    return {
      ...state,
      isFetched: true,
      error: action.payload.error
    }
  case SET_STATE_SEARCH:
    return Object.assign({}, state, action.params)
  default:
    return state
  }
}
